import React from 'react';

export const createUseGTMConfig =
  (gtmDefaultConfig: {
    id: string;
    url: string;
    auth?: string;
    preview?: string;
  }) =>
  () => {
    const gtmScript = React.useMemo(() => {
      if (!gtmDefaultConfig.url || !gtmDefaultConfig.id) return null;

      try {
        const url = new URL(gtmDefaultConfig.url);

        const params = new URLSearchParams();

        const base = `${url.origin}${url.pathname.replace(/\/$/, '')}/gtm.js`;

        params.set('id', gtmDefaultConfig.id);

        if (gtmDefaultConfig.auth)
          params.set('gtm_auth', gtmDefaultConfig.auth);

        if (gtmDefaultConfig.preview)
          params.set('gtm_preview', gtmDefaultConfig.preview);

        const src = `${base}?${params.toString()}`;

        return {
          id: gtmDefaultConfig.id,
          src,
        };
      } catch {
        return null;
      }
    }, [gtmDefaultConfig]);

    return gtmScript;
  };
